
      var _path, _path2, _circle, _circle2, _path3, _circle3, _path4, _path5, _path6, _circle4, _circle5, _path7, _circle6, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconEsim = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M82.297 24H48.066c-1.279 0-2.503.52-3.39 1.442L34.315 36.213A4.703 4.703 0 0 0 33 39.473V90.2C33 93.403 35.644 96 38.906 96h42.188C84.356 96 87 93.403 87 90.2V28.695A4.697 4.697 0 0 0 82.297 24Z",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.795 64.128c-2.4 0-3.856-1.664-3.856-3.936 0-2.272 1.472-3.856 3.792-3.856 2.24 0 3.648 1.472 3.648 3.696 0 .208-.016.432-.016.768h-5.12c.176.752.784 1.264 1.632 1.264.784 0 1.136-.304 1.344-.576l2 .704c-.56 1.2-1.616 1.936-3.424 1.936Zm-1.488-4.816h2.976c-.16-.576-.688-1.008-1.456-1.008-.752 0-1.28.352-1.52 1.008Zm9.947 4.816c-1.76 0-3.344-.64-4.112-1.392l1.136-1.888c.512.4 1.808.976 3.2.976.64 0 1.232-.192 1.232-.656 0-1.152-5.168-.544-5.168-3.888 0-1.76 1.52-2.784 3.584-2.784 1.68 0 3.056.752 3.696 1.44l-1.296 1.488c-.64-.528-1.44-.832-2.464-.832-.384 0-.976.144-.976.576 0 1.152 5.088.576 5.088 3.952 0 1.952-1.552 3.008-3.92 3.008ZM61.386 64v-9.408h2.432V64h-2.432Zm4.063 0v-9.408h2.176l2.88 5.648 2.928-5.648h2.192V64h-2.32v-4.752l-2 3.952h-1.648l-1.888-3.856V64h-2.32Z",
  fill: "var(--theme-primary, #810ea9)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  transform: "matrix(0 1 1 0 102 77)",
  stroke: "#000",
  strokeWidth: 3.8
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  transform: "matrix(0 1 1 0 104 49)",
  stroke: "#000",
  strokeWidth: 3.8
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M86.825 80h15.417M86 52h18.333",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinejoin: "round"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  transform: "matrix(0 1 1 0 96 63)",
  stroke: "#000",
  strokeWidth: 3.8
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M86.409 66h10.833",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M52 25v16M52 79v16M60 25v16M60 79v16M68 25v16M68 79v16",
  stroke: "#000",
  strokeWidth: 3.667,
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M76 69.136v9.197c0 .92-.746 1.667-1.667 1.667H45.667c-.92 0-1.667-.746-1.667-1.667v-9.197m0-19.26v-8.21c0-.92.746-1.666 1.667-1.666h28.666c.92 0 1.667.746 1.667 1.667v8.21",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 80,
  r: 3,
  transform: "rotate(90 15 80)",
  stroke: "#000",
  strokeWidth: 3.8
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 52,
  r: 3,
  transform: "rotate(90 13 52)",
  stroke: "#000",
  strokeWidth: 3.8
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M33.417 80H18M34.242 52H15.91",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinejoin: "round"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 66,
  r: 3,
  transform: "rotate(90 21 66)",
  stroke: "#000",
  strokeWidth: 3.8
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.833 66H23",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M13 40h12",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M82.2972 24L48.0659 24C46.7871 24 45.5635 24.5207 44.6769 25.4422L34.3139 36.2133C33.4709 37.0895 33 38.2581 33 39.4739L33 90.1991C33 93.4029 35.6443 96 38.9062 96L81.0937 96C84.3557 96 87 93.4029 87 90.1991L87 28.6959C87 26.0986 84.8945 24 82.2972 24Z\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n<path d=\"M47.7947 64.128C45.3947 64.128 43.9387 62.464 43.9387 60.192C43.9387 57.92 45.4107 56.336 47.7307 56.336C49.9707 56.336 51.3787 57.808 51.3787 60.032C51.3787 60.24 51.3627 60.464 51.3627 60.8H46.2427C46.4187 61.552 47.0267 62.064 47.8747 62.064C48.6587 62.064 49.0107 61.76 49.2187 61.488L51.2187 62.192C50.6587 63.392 49.6027 64.128 47.7947 64.128ZM46.3067 59.312H49.2827C49.1227 58.736 48.5947 58.304 47.8267 58.304C47.0747 58.304 46.5467 58.656 46.3067 59.312ZM56.2542 64.128C54.4942 64.128 52.9102 63.488 52.1422 62.736L53.2782 60.848C53.7902 61.248 55.0862 61.824 56.4782 61.824C57.1182 61.824 57.7102 61.632 57.7102 61.168C57.7102 60.016 52.5422 60.624 52.5422 57.28C52.5422 55.52 54.0622 54.496 56.1262 54.496C57.8062 54.496 59.1822 55.248 59.8222 55.936L58.5262 57.424C57.8862 56.896 57.0862 56.592 56.0622 56.592C55.6782 56.592 55.0862 56.736 55.0862 57.168C55.0862 58.32 60.1742 57.744 60.1742 61.12C60.1742 63.072 58.6222 64.128 56.2542 64.128ZM61.3863 64V54.592H63.8183V64H61.3863ZM65.4488 64V54.592H67.6248L70.5048 60.24L73.4328 54.592H75.6248V64H73.3048V59.248L71.3048 63.2H69.6568L67.7688 59.344V64H65.4488Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<circle cx=\"3\" cy=\"3\" r=\"3\" transform=\"matrix(-1.19249e-08 1 1 1.19249e-08 102 77)\" stroke=\"black\" stroke-width=\"3.8\"/>\r\n<circle cx=\"3\" cy=\"3\" r=\"3\" transform=\"matrix(-1.19249e-08 1 1 1.19249e-08 104 49)\" stroke=\"black\" stroke-width=\"3.8\"/>\r\n<path d=\"M86.8254 80L102.242 80\" stroke=\"black\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/>\r\n<path d=\"M86 52L104.333 52\" stroke=\"black\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"3\" cy=\"3\" r=\"3\" transform=\"matrix(-1.19249e-08 1 1 1.19249e-08 96 63)\" stroke=\"black\" stroke-width=\"3.8\"/>\r\n<path d=\"M86.4089 66L97.2423 66\" stroke=\"black\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/>\r\n<path d=\"M52 25V41\" stroke=\"black\" stroke-width=\"3.66667\" stroke-linejoin=\"round\"/>\r\n<path d=\"M52 79V95\" stroke=\"black\" stroke-width=\"3.66667\" stroke-linejoin=\"round\"/>\r\n<path d=\"M60 25V41\" stroke=\"black\" stroke-width=\"3.66667\" stroke-linejoin=\"round\"/>\r\n<path d=\"M60 79V95\" stroke=\"black\" stroke-width=\"3.66667\" stroke-linejoin=\"round\"/>\r\n<path d=\"M68 25V41\" stroke=\"black\" stroke-width=\"3.66667\" stroke-linejoin=\"round\"/>\r\n<path d=\"M68 79V95\" stroke=\"black\" stroke-width=\"3.66667\" stroke-linejoin=\"round\"/>\r\n<path d=\"M76 69.1358V78.3333C76 79.2538 75.2538 80 74.3333 80H45.6667C44.7462 80 44 79.2538 44 78.3333V69.1358M44 49.8765V41.6667C44 40.7462 44.7462 40 45.6667 40H74.3333C75.2538 40 76 40.7462 76 41.6667V49.8765\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n<circle cx=\"15\" cy=\"80\" r=\"3\" transform=\"rotate(90 15 80)\" stroke=\"black\" stroke-width=\"3.8\"/>\r\n<circle cx=\"13\" cy=\"52\" r=\"3\" transform=\"rotate(90 13 52)\" stroke=\"black\" stroke-width=\"3.8\"/>\r\n<path d=\"M33.4167 80L18.0001 80\" stroke=\"black\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/>\r\n<path d=\"M34.2422 52L15.9089 52\" stroke=\"black\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"21\" cy=\"66\" r=\"3\" transform=\"rotate(90 21 66)\" stroke=\"black\" stroke-width=\"3.8\"/>\r\n<path d=\"M33.8333 66L22.9999 66\" stroke=\"black\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/>\r\n<path d=\"M13 40H25\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-esim.65367d249e0bfb7b3c2758c2d61f96e4.svg"),
        {
          React: SvgIconEsim,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      